module.exports = __webpack_public_path__ + "static/media/list.2047d245.svg";